export const SET_PRINT_FEEDS_START = "SET_PRINT_FEEDS_START";
export const SET_PRINT_FEEDS_FINISH = "SET_PRINT_FEEDS_FINISH";
export const SET_PRINT_FEEDS_FAILED = "SET_PRINT_FEEDS_FAILED";
export const SET_FILTERED_PRINT_FEEDS = "SET_FILTERED_PRINT_FEEDS";
export const SET_ONLINE_FEEDS = "SET_ONLINE_FEEDS";
export const SET_FILTERED_ONLINE_FEEDS = "SET_FILTERED_ONLINE_FEEDS";
export const SET_ONLINE_FEEDS_START = "SET_ONLINE_FEEDS_START";
export const SET_ONLINE_FEEDS_FINISH = "SET_ONLINE_FEEDS_FINISH";
export const SET_ONLINE_FEEDS_FAILED = "SET_ONLINE_FEEDS_FAILED";
export const GET_MORE_ONLINE_FEEDS = "GET_MORE_ONLINE_FEEDS";
export const GET_MORE_PRINT_FEEDS = "GET_MORE_PRINT_FEEDS";
export const INIT_FILTERS = "INIT_FILTERS";
export const SET_PUBLICATION_TYPES = "SET_PUBLICATION_TYPES";
export const SET_PUBLICATION = "SET_PUBLICATION";
export const SET_EDITION_LIST = "SET_EDITION_LIST";
export const SET_KEYWORDS_PER_ENTITY = "SET_KEYWORDS_PER_ENTITY";
export const SET_CLIENT_DETAILS = "SET_CLIENT_DETAILS";
export const SET_SELECTED_CLIENT_DETAILS = "SET_SELECTED_CLIENT_DETAILS";
export const SET_USER_PASSWORD_DETAILS = "SET_USER_PASSWORD_DETAILS";
export const SET_CLIENT_DETAILS_START = "SET_CLIENT_DETAILS_START";
export const SET_CLIENT_DETAILS_FAILED = "SET_CLIENT_DETAILS_FAILED";
export const SET_CLIENT_TAGS = "SET_CLIENT_TAGS";
export const SET_CLIENT_QUALITATIVE_SETTINGS = "SET_CLIENT_QUALITATIVE_SETTINGS";
export const SET_ZONES = "SET_ZONES";
export const SET_CATEGORY = "SET_CATEGORIES";
export const SET_REPORTERS = "SET_REPORTERS";
export const SET_ENTITY_LIST = "SET_ENTITY_LIST";
export const SET_CLIENT_LIST = "SET_CLIENT_LIST";
export const SET_TONALITY_LIST = "SET_TONALIRT_LIST";
export const SET_ENTITY_DETAILS = "SET_ENTITY_DETAILS";
export const SET_SELECTED_ENTITY_DETAILS = "SET_SELECTED_ENTITY_DETAILS";
export const SET_ENTIIY_DETAILS_START = "SET_ENTITY_DETAILS_START";
export const SET_ENTITY_DETAILS_FAILED = "SET_ENTITY_DETAILS_FAILED";
export const SET_PARENT_CLIENT_ID = "SET_PARENT_CLIENT_ID";
export const SET_PRESS_RELEASE = "SET_PRESS_RELEASE";
export const SET_FETCH_SOCIAL_ENTITY_START = "SET_FETCH_SOCIAL_ENTITY_START";
export const SET_FETCH_SOCIAL_ENTITY_FINISH = "SET_FETCH_SOCIAL_ENTITY_FINISH";
export const SET_FETCH_SOCIAL_ENTITY_FAILED = "SET_FETCH_SOCIAL_ENTITY_FAILED";
export const SET_SOCIAL_ENTITY_LIST = "SET_SOCIAL_ENTITY_LIST";
export const SET_REPORTS_ENTITY_LIST = "SET_REPORTS_ENTITY_LIST";
export const SET_SOCIAL_ENTITY_DETAILS = "SET_SOCIAL_ENTITY_DETAILS";
export const SET_SOCIAL_ENTIIY_DETAILS_START =
  "SET_SOCIAL_ENTITY_DETAILS_START";
export const SET_SOCIAL_ENTITY_DETAILS_FAILED =
  "SET_SOCIAL_ENTITY_DETAILS_FAILED";
export const SET_JOURNALIST_ACCESS = "SET_JOURNALIST_ACCESS";
export const RESET_PUBLICATIONS = "RESET_PUBLICATIONS";
export const SET_FEED_TAGS_START = "SET_FEED_TAGS_START";
export const SET_FEED_TAGS_FINISH = "SET_FEED_TAGS_FINISH";
export const SET_FEED_TAGS_FAILED = "SET_FEED_TAGS_FAILED";
export const SET_INLINE_FILTER = "SET_INLINE_FILTER";
export const SET_AUTH = "SET_AUTH";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const SET_CHANNEL_TYPE = "SET_CHANNEL_TYPE";
export const SET_REPORTS_FOR_TV = "SET_REPORTS_FOR_TV";
export const SET_LANGUAGES = "SET_LANGUAGES";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_CLIENT_MASTER = "SET_CLIENT_MASTER";
export const SET_CLIENT_SUB_USER = "SET_CLIENT_SUB_USER";
export const SET_CLIENT_SUB_USER_FILTER_DATA = "SET_CLIENT_SUB_USER_FILTER_DATA";
export const SET_CLIENT_MASTER_LIST = "SET_CLIENT_MASTER_LIST";
export const SET_CLIENT_LANGUAGE = "SET_CLIENT_LANGUAGE";
export const SET_STATE = "SET_STATE";